import { useEffect, useLayoutEffect, useState } from 'react';
import { makeStyles, } from '@material-ui/core';
import clsx from "clsx";
import { useDispatch, useSelector } from 'react-redux';
import UtilService from '../../../../../../../helper/service';
import AnalyzeKeyMomentPopOut from '../../../../../../atoms/creator/analyzeKeyMomentPopout';
import { updateOnBoardingSettings } from '../../../../../../../store/actions/creator/creatorOnBoarding';

const useStyles = makeStyles(() => ({
  agendaRoot: {
    display: 'flex',
    width: '100%',
    minHeight: 80,
    position: 'relative',
  },
  title: {
    minWidth: 60,
    background: '#fff',
    padding: '8px 7px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    border: '1px solid rgba(0, 0, 0, 0.2)',
    // boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    color: '#0179EE',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    cursor: 'context-menu',
  },
  clock: {
    width: 12,
    height: 12,
    marginRight: 3
  },
  timeLabel: {
    fontFamily: 'Spartan-extrabold',
    fontSize: 10,
    marginRight: 3
  },
  segmentWord: {
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    textTransform: 'uppercase',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
  },
  textBlack: {
    color: '#323232',
  },
  textEllipsis: {
    maxWidth: '100%',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    overflowWrap: 'break-word'
  },
  drag_title: {
    minWidth: 60,
    padding: '4px 10px',
    borderRadius: 12,
    borderTopLeftRadius: 0,
    color: '#0179EE',
    fontFamily: 'roboto-regular',
    fontSize: 12,
    marginLeft: -4,
  },
  box: {
    width: 30,
    height: 20,
    zIndex: 0,
    background: '#fff',
    padding: 4,
    border: '1px solid rgba(0, 0, 0, 0.2)',
    // boxShadow: "0 0 5px rgba(0, 0, 0, 0.2)",
    borderTopRightRadius: 12,
    borderTopLeftRadius: 12,
  },
  hidden: {
    width: 28,
    height: 5,
    background: '#fff',
    position: 'absolute',
    left: 1,
    marginTop: -3
  },
  resizable: {
    width: 16,
    position: 'relative',
    top: 0,
  },
  bar: {
    width: '100%',
    height: 24,
    zIndex: -1,
    position: 'absolute',
    background: '#e5f1fe',
  },
  times: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    color: '#333333',
    fontSize: 12,
    fontFamily: 'roboto-bold',
    marginBottom: -15
  },
  iconRBox: {
    padding: 5,
    display: 'flex',
    justifyContent: 'flex-start',
    marginTop: -25
  },
  iconLBox: {
    padding: 5,
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: -18,
    cursor: 'pointer'
  },
  description: {
    padding: '6px 0',
    background: '#fff',
    paddingBottom: 18,
    boxShadow: "0 3px 4px rgba(0, 0, 0, 0.1)",
    borderBottomLeftRadius: 4,
    borderBottomRightRadius: 4
  },
  textField: {
    "& .MuiInputBase-root": {
      color: '#0179EE',
      fontFamily: 'roboto-regular',
      fontSize: 12,
      marginTop: -4,
      background: '#e5f1fe',
      padding: '5px'
    }
  },
  pencil: {
    position: 'absolute',
    zIndex: 100,
    cursor: 'pointer'
  },
  iconDone: {
    position: 'absolute',
    zIndex: 100,
    cursor: 'pointer',
    color: '#1db859',
    margin: '-2px 0 0 1px'
  },
  popover: {
    background: '#fff',
    width: 226,
    boxShadow: '0px 0px 10px #00000033',
    borderRadius: 10,
    marginTop: 6,
  },
  header: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    margin: '0 0 -2px 12px'
  },
  popperTitle: {
    fontFamily: 'roboto-bold',
    color: '#606B76',
    fontSize: 14
  },
  name_index: {
    margin: '0 7px',
    fontSize: 18
  },
  label_index: {
    fontFamily: 'Spartan-bold',
    letterSpacing: 1.2,
    paddingTop: 4,
    textTransform: 'uppercase'
  },
  popperBadgeIcon: {
    width: 20,
    height: 20
  },
  mb20: {
    marginBottom: '20px !important'
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#1DB859',
    fontSize: 12,
    margin: 0,
    '& p:first-of-type': {
      margin: '0 7px',
      fontSize: 18,
    },
    '& p:nth-of-type(2)': {
      fontFamily: 'Spartan-bold',
      letterSpacing: 1.2,
      paddingTop: 4,
      textTransform: 'uppercase',
    }
  },
  btnBox: {
    display: 'flex',
    justifyContent: 'flex-end'
  },
  btn: {
    marginTop: 18,
    marginLeft: 5,
    padding: '3px 4px 3px 4px',
    color: '#697683',
    fontFamily: 'roboto-regular',
    fontSize: 10,
    background: '#F0F0F0',
    borderRadius: 6,
    textTransform: 'none',
    '&:hover': {
      background: '#e7e5e5',
    },
    '& img': {
      marginRight: 3
    }
  },
  label: {
    fontSize: 12,
    fontFamily: 'roboto-bold',
    color: '#697683',
    textAlign: 'left',
  },
  smallRow: {
    display: 'flex',
    flexDirection: 'row',
    flex: 1,
    alignItems: 'center',
    fontFamily: 'roboto-bold',
    color: '#8191A1',
    '& img': {
      width: 12,
      height: 12,
      marginRight: 3
    }
  },
  pane: {
    display: 'flex',
    flexDirection: 'row',
    fontFamily: 'Spartan-bold',
    fontSize: 8,
    color: '#8191A1',
    marginTop: 6
  },
}));

function AgendaSection(props: any) {
  const classes = useStyles();
  const dispatch = useDispatch();

  const { userPreferences, module4Settings} = useSelector((state: any) => state.creatorOnBoarding);
  const { module4Data } = userPreferences;
  const { session, analyze } = module4Data.value;

  const { graphZoom, analyseStart, analyseEnd, timeline } = module4Settings;
  const { started_at, session_status, range_immersion, range_safety } = session;
  const { lineStep, onZoom } = props;
  const start_at = Math.floor(analyseStart ? analyseStart : started_at);
  const markers: any = analyze.agenda_markers;
  const identifiers: any = [];

  let notes = markers.filter((item: any) => item.marker_type === 1 && item.start_marker_at !== '0')

  const [agendas, setAgendas] = useState(notes);
  const [curDrag] = useState(0);
  const [curDraggingId] = useState(-1);
  const [agendaPopup, setAgendaPopup] = useState(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const [clipName, setClipName] = useState<string>('Clip ');
  const [immersion, setImmersion] = useState<any>(null);
  const [safety, setSafety] = useState<any>(null);
  const [curAgenda, setCurAgenda] = useState<any>(null);

  const start = 0;
  const end = Number(analyseEnd);

  useLayoutEffect(() => {
    window.addEventListener('resize', updateEditNoteWidth);
  })

  useEffect(() => {
    if (timeline) {
      const hasKey = document.getElementById("agenda_" + timeline?.marker_id)
      if (hasKey) {
        hasKey.click();
        dispatch(updateOnBoardingSettings('timeline', null))
      }
    }
  }, [timeline])

  useEffect(() => {
    updateEditNoteWidth();
  }, [graphZoom]);

  useEffect(() => {
    if (!markers || !analyseStart || !analyseEnd) return;
    notes = markers.filter((item: any) => item.marker_type === 1 && item.start_marker_at !== '0');
    setAgendas(notes);
  }, [markers, analyseStart, analyseEnd]);

  const updateEditNoteWidth = () => {
    const timer1 = setTimeout(() => {
      const commentContainer = document.getElementById("agenda_container");
      if (!commentContainer) return;
    }, 100)
    return () => {
      clearTimeout(timer1)
    }
  }

  const getNoteWidth = (item: any) => {
    return (item.end_marker_at - item.start_marker_at) * lineStep / Math.pow(graphZoom, 2);
  }

  const getEpochTime = (epoch_time: number) => {
    if (session_status === 'COMPLETED' && identifiers.length > 0) {
      return UtilService.secondsToHms(Number(epoch_time) - analyseStart);
    } else {
      return UtilService.secondsToHms(Number(epoch_time) - analyseStart);
    }
  };

  const getRuntime = (epoch_start: number, epoch_end: number) => {
    return UtilService.overviewHighlightsTimeFormat(epoch_end - epoch_start);
  };

  const showAgendaPopup = async (event: any, data: any) => {

    setAnchorEl(event.currentTarget);

    Promise.all([
      getImmersion(data),
      getSafety(data)
    ])

    setAgendaPopup(true);

  }

  const getImmersion = async (data: any) => {
    const newImmersion = range_immersion.find((item: any) => item.end === Number(data.end_marker_at) && item.start === Number(data.start_marker_at))
    setImmersion(newImmersion);
  }

  const getSafety = async (data: any) => {
    const newSafety = range_safety.find((item: any) => item.end === Number(data.end_marker_at) && item.start === Number(data.start_marker_at))
    setSafety(newSafety);
  }

  const onItemBodyClick = (event: any, item: any) => {
    setAnchorEl(null);
    setImmersion(null);
    setSafety(null);

    showAgendaPopup(event, item);

    setCurAgenda(item);
    setClipName(item.marker_title);
  };

  const getEditStartXPosition = (item: any) => {
    const xPosition = ((parseInt(item.start_marker_at) - start_at - start) / Math.pow(graphZoom, 2)) * lineStep;
    return xPosition;
  }

  return (
    <div style={{ position: 'relative', paddingTop: 8 }}>
      <div
        className={classes.agendaRoot}
        id={'agenda_container'}>
        {
          agendas
            .filter((item: any) => (item.start_marker_at - start_at - start) >= 0 && (item.end_marker_at - start_at - end) <= 1)
            .map((item: any, key: number) =>
              <div key={key} style={{ position: 'relative', zIndex: 0 }}>
                <div style={{ position: 'absolute', paddingBottom: 12, left: `${getEditStartXPosition(item)}px`, }}>

                  <div
                    className={classes.box}
                    style={{ visibility: 'visible' }}
                  >
                    <img
                      src={'/assets/icons/agenda-icon.svg'}
                      style={{ marginTop: 2, marginLeft: 3 }}
                      alt={'img'}
                      className={classes.pencil}
                    />
                  </div>

                  <>
                    <div className={classes.hidden}></div>
                  </>

                  <div>

                    <div className='handle'>
                      <div>
                        <div
                          className={clsx(classes.title, classes.textBlack)}
                          style={{
                            width: getNoteWidth(item),
                            cursor: 'pointer'
                          }}
                          id={'agenda_' + item.marker_id}
                          onClick={(event: any) => onItemBodyClick(event, item)}
                        >
                          <div className={classes.textEllipsis}>
                            <span>{item.marker_title}</span>
                          </div>
                        </div>

                      </div>

                      {curDraggingId === Number(item.marker_id) &&
                        <div className={clsx(classes.times, classes.drag_title)}
                          style={{
                            width: ((item.end_marker_at - item.start_marker_at) / Math.pow(graphZoom, 2)) * lineStep,
                          }}
                        >
                          <span className={classes.textBlack}>
                            {UtilService.getStartTimeLabel((item.start_marker_at - start_at + curDrag * Math.pow(graphZoom, 2)), 1, 0)}
                          </span>
                          <span className={classes.textBlack}>
                            {UtilService.getEndTimeLabel((item.start_marker_at - start_at + curDrag * Math.pow(graphZoom, 2)), (item.end_marker_at - start_at + curDrag * Math.pow(graphZoom, 2)), 1, 0)}
                          </span>
                        </div>
                      }

                    </div>
                  </div>
                </div>
              </div>
            )
        }

      </div>

      {agendaPopup && curAgenda && (immersion) &&
        <AnalyzeKeyMomentPopOut
          anchorEl={anchorEl}
          onZoom={() => {
            setAnchorEl(null);
            if (onZoom && curAgenda)
              onZoom((Number(curAgenda?.end_marker_at) - Number(curAgenda?.start_marker_at)), curAgenda?.start_marker_at);
          }}
          setAnchorEl={setAnchorEl}
          clipName={clipName}
          overlay={{
            segment_length: getRuntime(curAgenda['start_marker_at'], curAgenda['end_marker_at']),
            segment_end: getEpochTime(curAgenda['end_marker_at']),
            segment_start: getEpochTime(curAgenda['start_marker_at']),
            safety_color: safety?.color_indicator,
            safety_index: safety?.overall_index || '--',
            safety_indicator: safety?.context_indicator,
            overall_index: immersion?.overall_index,
            color_indicator: immersion?.color_indicator,
            color: immersion?.color_indicator,
            context_indicator: immersion?.context_indicator,
            type: 'Agenda',
            start: String(curAgenda['start_marker_at']),
            end: String(curAgenda['end_marker_at']),
            title: curAgenda.marker_title
          }}
        />
      }

    </div>
  );
}

export default AgendaSection;